import { render, staticRenderFns } from "./remoteWeb.vue?vue&type=template&id=fd28e39a&scoped=true&"
import script from "./remoteWeb.vue?vue&type=script&lang=js&"
export * from "./remoteWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd28e39a",
  null
  
)

export default component.exports